import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { Paper, Breadcrumbs, Typography, Link, Grid, Button, IconButton, Tooltip, CircularProgress, LinearProgress } from '@material-ui/core';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import GetAppIcon from '@material-ui/icons/GetApp';
import { ShareFolderCard, DownloadShareModal, SharedListCard } from '../components';
import { getPlatformConstantsAc } from '../../../shared_elements/actionCreators';
import { PageLoader, EmptyCollection, TableListComp } from '../../../shared_elements';
import { SCardLoader } from '../../../shared_elements/loaders';
import { imageMedia, videoTypes } from '../../../constants';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AppsIcon from '@material-ui/icons/Apps';
import axios from 'axios'
import { getSharedContentApi, downloadShareDataApi, downloadShareDataApiV3Json, shareLinkActivityApi } from '../apiServices';
import * as actions from '../../../shared_elements/actions'
import { trackPublicActivity } from '../../../utils/mixpanel';
class SharedRecordsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadShareData: {
        modal: false,
        email: '',
        jsonDownload: false
      },
      viewMode: 1,
      skeletonLoader: false,
      pageLoader: false,
      sharedData: {
        asset: null,
        list: [],
        navigation: []
      },
      refreshTimer:15,
    }
    this.getSharedContentApi = getSharedContentApi.bind(this);
    this.downloadShareDataApi = downloadShareDataApi.bind(this);
    this.downloadShareDataApiV3Json = downloadShareDataApiV3Json.bind(this);
    this.shareLinkActivityApi = shareLinkActivityApi.bind(this);
  }
  componentDidMount() {
    let shareType = this.props.match.params.key.slice(-2);
    this.getSharedContentApi(this.props, this.props.match.params.key, {}, 'skeletonLoader');
    this.shareLinkActivityApi(this.props, this.props.match.params.key, shareType == 'ff' ? 30 : 29);
    if (!this.props.pltConstants.filter(item => item.type === 'file_extension_drive').length) {
      this.props.getPlatformConstants();
    }
    trackPublicActivity('Page Visited', { page_title: 'Shared Content' })
  }

  componentWillUnmount() {
    this._unmounted = true;
    clearTimeout(this.shareStatusTimer);
    clearInterval(this.refreshInterval);
  }

  onPreviewActivity = (item, event) => {
    this.shareLinkActivityApi(this.props, this.props.match.params.key, 31);
    const previewUrl = document.createElement('a')
    previewUrl.href = `${window.location.protocol}//${window.location.hostname}/records/preview/${item.uuid}?shared=true`
    previewUrl.setAttribute('target', '_blank')
    document.body.appendChild(previewUrl)
    previewUrl.click()
  }

  downloadFile = (url, name) => {
    this.setState({ pageLoader: true })
    axios.get(url, { responseType: 'arraybuffer', })
      .then(response => {
        this.setState({ pageLoader: false })
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click()
      })
      .catch(error => this.setState({ pageLoader: false }))
  }

  render() {
    const { skeletonLoader, pageLoader, sharedData, downloadShareData, viewMode } = this.state;
    const { pltConstants } = this.props;    
    return (
      <section className="share-content-section">
        <div style={{ height: '70px', width: '100%' }}></div>
        <div className="share-header">
          <Grid container spacing={0} alignItems="center">
            <Grid item xs={12} sm={12} md={4}>
              <ul className="list-inline">
                <li className="list-inline-item">
                  <img width="32" src="https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/sparta_logo.png" alt="Logo" />
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <ul className="list-inline lessor-info">
                <li className="list-inline-item">
                  {sharedData.asset && sharedData.asset.lessor_logo ?
                    <img src={sharedData.asset.lessor_logo} alt={sharedData.asset.lessor} /> : null
                  }
                </li>
              </ul>
            </Grid>
          </Grid>
        </div>
        {
          sharedData.navigation?.length == 1 && sharedData?.share_status?.status === 0 ?
          <Paper elevation={0} style={{ maxWidth: '560px', margin: '60px auto', padding: '40px 32px', textAlign: 'center', border: '1px solid #e3e8f0', borderRadius: '12px', background: '#fafbfd' }}>
            <div style={{ position: 'relative', display: 'inline-flex', marginBottom: '24px' }}>
              <CircularProgress size={72} thickness={2.5} color="primary" />
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FolderOpenIcon color="primary" style={{ fontSize: '30px' }} />
              </div>
            </div>
            <Typography variant="h6" style={{ fontWeight: 600, color: '#1f2a44', marginBottom: '8px' }}>
              Preparing your shared content
            </Typography>
            <Typography variant="body2" style={{ color: '#5b6478', lineHeight: 1.6, marginBottom: '24px' }}>
              We're generating the data for this share link. This may take up to a few minutes.
              Your files will appear here automatically once they're ready.
            </Typography>
            {
              (() => {
                const { shared_objects, total_objects } = sharedData.share_status;
                const percentage = total_objects > 0 ? Math.min(100, Math.round((shared_objects / total_objects) * 100)) : null;
                return percentage !== null ?
                  <div style={{ maxWidth: '320px', margin: '0 auto' }}>
                    <LinearProgress variant="determinate" value={percentage} color="primary" style={{ height: '4px', borderRadius: '2px' }} />
                    <Typography variant="body2" style={{ color: '#1f2a44', fontWeight: 600, marginTop: '8px' }}>
                      {percentage}%
                    </Typography>
                  </div> :
                  <LinearProgress color="primary" style={{ height: '4px', borderRadius: '2px', maxWidth: '320px', margin: '0 auto' }} />
              })()
            }
            <div style={{ display: 'inline-flex', alignItems: 'center', marginTop: '16px', padding: '4px 12px', borderRadius: '16px', background: '#eef2f9', color: '#5b6478' }}>
              <Typography variant="caption" style={{ color: '#5b6478' }}>
                    Updating progress in <b style={{ color: '#1f2a44', fontVariantNumeric: 'tabular-nums' }}>{this.state.refreshTimer}s</b>
              </Typography>
            </div>
            <Typography variant="caption" display="block" style={{ color: '#8a93a6', marginTop: '12px' }}>
              You can keep this page open. No action is needed.
            </Typography>
            <Button onClick={() => window.location.reload()} color="primary" size="small" variant="outlined" startIcon={<RefreshIcon />} style={{ marginTop: '20px' }}>
              Refresh
            </Button>
          </Paper>:
        <>
        <Paper className="navigation-box" style={{minHeight:"46px"}}>
          <h4>
            {sharedData.asset && sharedData.asset.msn ? sharedData.asset.msn : ''}
            <span style={{display:'flex', marginTop:'10px', alignItems:'center'}}>
              {
                window.location.href.includes('*xx') && sharedData.list && sharedData.list.length ?
                  <a onClick={() => this.downloadFile(decodeURIComponent(sharedData.list[0].path), sharedData.list[0].name)} download ><CloudDownloadIcon color="primary" /></a>
                  :  skeletonLoader || sharedData.navigation?.length < 1? null:<Button
                    onClick={() => this.setState(prevState => ({
                      ...prevState,
                      downloadShareData: {
                        ...prevState.downloadShareData,
                        modal: true,
                        email: ''
                      }
                    }
                    ))}
                    color="primary"
                    size="small" variant="contained" style={{ marginLeft: '8px' }} startIcon={<GetAppIcon />}
                  >
                    Download Asset as Zip
                  </Button>
              }
            </span>
          </h4>
          <Breadcrumbs maxItems={3} aria-label="breadcrumb">
            {sharedData.navigation.map((nav, index) =>
              sharedData.navigation.length - 1 === index ? <Typography>{nav.name}</Typography> :
                <Link onClick={() => this.getSharedContentApi(this.props, nav.share_key, { preview: true, parent: index !== 0 ? sharedData.navigation[sharedData.navigation.length - 1].uuid : null }, 'pageLoader')}>{nav.name}</Link>
            )}
          </Breadcrumbs>
        </Paper>
        <div className="shared-content-list">
          <ul className="list-inline flex-centered data-room-layout-options" style={{justifyContent:'space-between'}}>
            <li className="list-inline-item">
              <span className="data-rm-switcher">
                <span style={{ cursor: 'pointer' }} className={viewMode === 1 ? 'active' : ''} onClick={() => this.setState({ viewMode: 1 })}>
                  <AppsIcon color={viewMode === 1 ? 'primary' : 'default'} />
                </span>
                <span style={{ cursor: 'pointer' }} className={viewMode === 2 ? 'active' : ''} onClick={() => this.setState({ viewMode: 2 })}>
                  <ListAltIcon color={viewMode === 2 ? 'primary' : 'default'} />
                </span>
              </span>
            </li>
            {sharedData?.navigation?.length >1 && sharedData.list.length?
              <Button onClick={() => this.setState(prevState => ({ ...prevState, downloadShareData: { ...prevState.downloadShareData, modal: true, email: '', jsonDownload: true, folderLevel:sharedData?.navigation[sharedData?.navigation?.length-1] } }))} color="primary" size="small" variant="outlined" style={{ marginLeft: '8px', marginBottom:'7px',marginRight: '15px', }} startIcon={<GetAppIcon />}> Download Folder: {skeletonLoader?'--':sharedData?.navigation[sharedData?.navigation?.length-1]?.name}</Button>
            :null} 
          </ul>
        </div>
        <div className="shared-content-list">
          <ul className="list-inline">
            {skeletonLoader ? <SCardLoader count={20} /> : null}
            {sharedData.list && sharedData.list.length ?
              sharedData.list.map((item) =>
                <li className="list-inline-item">
                  {
                    viewMode === 1 ?
                      <ShareFolderCard
                        trackActivity= {()=>this.shareLinkActivityApi(this.props, item.share_key, 32)}
                        item={item}
                        fileIcons={pltConstants.filter(icon => icon.type === 'file_extension_drive')}
                        onChangeNav={() => this.getSharedContentApi(this.props, item.share_key, { parent: sharedData.navigation[sharedData.navigation.length - 1].uuid, preview: true }, 'pageLoader')}
                        onPreviewActivity={() => this.onPreviewActivity(item)}
                        sharedData={sharedData}
                      />
                      : null
                  }
                </li>
              ) : null}
          </ul>
          {
            viewMode === 2 ?
              <TableListComp
                heads={[
                  { label: 'Name', sortOption: false },
                  { label: 'Size / Count', sortOption: false },
                ]}
                data={sharedData.list.map((item, index) =>
                  <SharedListCard
                    item={item}
                    index={index}
                    sharedData={sharedData}
                    fileIcons={pltConstants.filter(icon => icon.type === 'file_extension_drive')}
                    onChangeNav={() => this.getSharedContentApi(this.props, item.share_key, { parent: sharedData.navigation[sharedData.navigation.length - 1].uuid, preview: true }, 'pageLoader')}
                  />
                )}
                noRecord={sharedData.list.length ? null :
                  <div></div>
                }
              />
              : null
          }
        </div>
        </>
        }
        <DownloadShareModal
          downloadShareData={downloadShareData}
          onFieldChange={(value) => this.setState(prevState => ({
            ...prevState,
            downloadShareData: {
              ...prevState.downloadShareData,
              email: value
            }
          }))}
          toggleModalFn={() => this.setState(prevState => ({
            ...prevState,
            downloadShareData: {
              ...prevState.downloadShareData,
              modal: false,
              email: '',
              jsonDownload: false
            }
          }))}
          onDownloadShareData={() => downloadShareData.jsonDownload
            ? this.downloadShareDataApiV3Json(this.props, downloadShareData.email, downloadShareData?.folderLevel)
            : this.downloadShareDataApi(this.props, this.props.match.params.key, downloadShareData.email)
          }
        />
        {!sharedData.list.length && !skeletonLoader && !(sharedData.navigation?.length == 1 && sharedData?.share_status?.status == 0) ? <EmptyCollection title="No Records Found" /> : null}
        {pageLoader ? <PageLoader /> : null}
      </section>
    )
  }
}
const mapStateToProps = state => ({
  pltConstants: state.shareReducer.pltConstants,
})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getPlatformConstants: () => dispatch(getPlatformConstantsAc({ constant_types: ['file_extension_drive'] })),
  }
}
export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(SharedRecordsList))
